var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLanguage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 29.41 29.41",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.61,7.82h12V21.53h-12a1,1,0,0,1-1-1V8.85A1,1,0,0,1,1.61,7.82Zm2,11h1a.51.51,0,0,0,.49-.37l.39-1.37H8l.4,1.37a.55.55,0,0,0,.5.37h1a.52.52,0,0,0,.49-.68L7.94,10.86a.52.52,0,0,0-.49-.35H6.06a.52.52,0,0,0-.49.35L3.11,18.11A.52.52,0,0,0,3.6,18.79Zm4-3.36H5.94l.47-1.6c.15-.52.34-1.43.34-1.43h0s.18.91.33,1.43ZM28,8.85V20.5a1,1,0,0,1-1,1H15V7.82H27A1,1,0,0,1,28,8.85ZM26,12.27a.52.52,0,0,0-.52-.51H22.7v-.69a.51.51,0,0,0-.52-.51H21.5a.52.52,0,0,0-.52.51v.69H18.24a.51.51,0,0,0-.51.51V13a.51.51,0,0,0,.51.51h4.9a6.59,6.59,0,0,1-1.29,1.86,8.37,8.37,0,0,1-.74-.9.53.53,0,0,0-.69-.15l-.31.19-.28.17a.51.51,0,0,0-.16.73,9.87,9.87,0,0,0,.9,1.1,10.5,10.5,0,0,1-1.12.77.53.53,0,0,0-.18.7l.34.59a.53.53,0,0,0,.72.19,17.77,17.77,0,0,0,1.52-1.07,14.48,14.48,0,0,0,1.51,1.07.53.53,0,0,0,.72-.19l.34-.59a.53.53,0,0,0-.18-.7c-.38-.23-.76-.5-1.12-.77a7.54,7.54,0,0,0,1.83-3h.49A.52.52,0,0,0,26,13Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLanguage);
export default __webpack_public_path__ + "static/media/language.46578162.svg";
export { ForwardRef as ReactComponent };